import { recordEvent, recordEventCustomOnly, errorTag } from 'utilities/uTagging';
import { PATH_OPEN_YOUR_ACCOUNT } from 'constants/uTagConstants/paths';
import UtagHelper from 'utilities/utagHelper';

export const doTagAccordionClick = isOpen => {
    const openCloseText = isOpen ? 'open' : 'close';
    recordEventCustomOnly({
        action: openCloseText,
        format: 'chevron',
        component: 'form',
        element: 'promoCode',
        eventCategory: '/onboarding/step1/personalData',
        eventAction: 'promoCodeChevron',
        eventLabel: openCloseText,
    });
};

export const doTagFocusPromoInputText = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textbox',
        component: 'form',
        element: 'promoCode',
        eventCategory: '/onboarding/step1/personalData',
        eventAction: 'clickTextBox',
        eventLabel: 'promoCodeTextBox',
    });
};

export const doTagClickOkButtonPromo = () => {
    recordEventCustomOnly({
        action: 'click',
        format: 'button',
        component: 'form',
        element: 'ok',
        eventCategory: '/onboarding/step1/personalData',
        eventAction: 'clickButton',
        eventLabel: 'okButton',
    });
};

export const doTagHandleOnRemoveCode = products => {
    recordEventCustomOnly({
        categoriaEvento: '/onboarding/abre-tu-cuenta/',
        accionEvento: `modulo codigo promocion / ${products.get('productsDescription')}`,
        etiquetaEvento: 'cerrar',
    });
};

export const doTagHandleSeeConditionsLinkClick = products => {
    recordEventCustomOnly({
        categoriaEvento: '/onboarding/abre-tu-cuenta/',
        accionEvento: `modulo codigo promocion / ${products.get('productsDescription')}`,
        etiquetaEvento: 'ver condiciones de la promocion',
    });
};

export const doTagValidPromoCode = ({ userProfile, products, code }) => {
    const jointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
    recordEvent(
        '/onboarding/abre-tu-cuenta/',
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        userProfile.investmentType,
        undefined,
        undefined,
        {
            categoriaEvento: '/onboarding/abre-tu-cuenta/',
            accionEvento: 'modulo codigo promocion',
            tipoProceso: 'onboarding',
            pasoProceso: 'abre tu cuenta',
            tipoPagina: 'pagina de inicio',
            etiquetaEvento: products.get('productsDescription'),
            onboardingPromoCode: code === '' ? 'sin codigo promocional' : code,
            tipoUsuario: 'no cliente',
            intervinientes: jointHolderInfo.isJointHolderAccount ? jointHolderInfo.isJointHolderAccount : '',
            tipoTitular: jointHolderInfo.typeHolder ? jointHolderInfo.typeHolder : '',
            tipoUsuarioInterviniente: jointHolderInfo.typeUserHolder ? jointHolderInfo.typeUserHolder : '',
        }
    );
};

export const doTagErrorPromoCode = ({ error, customErrorDescription }) => {
    errorTag(error.body, PATH_OPEN_YOUR_ACCOUNT, error.req.url, error.statusCode, customErrorDescription);
};
